export * from './location-list/location-list.component';
export * from './location-create/location-create.component';
export * from './location-detail/location-detail.component';
export * from './location-edit/location-edit.component';
export * from './ubicacion-batch-create/ubicacion-batch-create.component';

